<script setup>
import combinationStorage from '@/services/combination-storage';
import { defineOptions, onMounted, reactive } from 'vue';
import Pagination from '@/components/Pagination.vue';

defineOptions({
  name: 'ModalBodyCategoryList'
});

const state = reactive({
  currentCategory: null,
  items: [],
  q: '',
  page: 1,
  pagination: [],
});

onMounted(() => {
  loadItems();
});

async function loadItems() {
  const connectorProductIds = []

  if (combinationStorage.initialItem && combinationStorage.terminalItem) {
    connectorProductIds.push(combinationStorage.initialItem.productId);
    connectorProductIds.push(combinationStorage.terminalItem.productId);
  }

  const res = await u.$http.get(
    '@combination_ajax/loadCategoryList',
    {
      params: {
        q: state.q,
        path: combinationStorage.categoryPath,
        page: state.page,
        combinationShowIn: combinationStorage.categoryType,
        mappingIds: combinationStorage.mappingIds,
        connectorProductIds: connectorProductIds,
        getMappingConnector: combinationStorage.getMappingConnector ? 1 : 0,
      }
    }
  );

  state.currentCategory = res.data.data.currentCategory;
  state.items = res.data.data.items;
  state.pagination = res.data.data.pagination;
}

async function goToPage(v) {
  state.page = v;

  await loadItems();
}
</script>

<template>
  <div v-if="state.items" class="modal-body pt-0 position-relative">
    <nav v-if="combinationStorage.showBreadcrumb"
      aria-label="breadcrumb" class="c-breadcrumb-nav d-none d-md-block p-0">
      <div class="container-fluid p-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="javascript://" @click="combinationStorage.backToComponent('buttons')">產品分類</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ state.currentCategory?.title }}
          </li>
        </ol>
      </div>
    </nav>

    <button class="c-prev btn d-md-none mb-3 border-0 px-3 w-100 text-start position-absolute top-0 start-0"
      @click="combinationStorage.backToComponent('buttons')">
      <i class="fa-regular fa-chevron-left me-2"></i>產品分類
    </button>

    <div class="c-search d-flex mb-4 position-relative">
      <input v-model="state.q" type="text" class="form-control" placeholder="分類搜尋">
      <i class="fa-regular fa-magnifying-glass"></i>
      <button type="button" class="btn btn-dark"
        @click="loadItems"
      >搜尋
      </button>
    </div>

    <ul class="c-product-card-list">
      <li v-for="item in state.items" :key="'category-' + item.id">
        <a href="javascript://" class="text-decoration-none btn border-0 p-0 text-start h-100"
          @click="combinationStorage.goToProductList(item.path)">
          <div class="card h-100">
            <img :src="item.image"
              class="card-img-top" alt="product title">
            <div class="card-body">
              <h2 class="card-title mb-0 h5 position-relative">
                {{ item.title }}
              </h2>
            </div>
          </div>
        </a>
      </li>
    </ul>

    <Pagination :item="state.pagination"
      :enableLessAndMore="false"
      :enableFirstAndLast="false"
      :icon="{ prev: 'fa-regular fa-chevron-left', next: 'fa-regular fa-chevron-right' }"
      @go="goToPage"
    ></Pagination>
  </div>
</template>
